import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListCompanyVehicleSetupsActions as Actions,
  ListCompanyVehicleSetupsRequestAction as RequestAction,
} from 'store/ducks/companyVehicleSetups';

export function* listCompanyVehicleSetupsRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('company-vehicle-setups', {
      ...query,
      asList: 1,
      orderBy: 'vehicleTypeName',
      direction: 'asc',
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
